const _checkImageExists = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
};

export const getClientLogoUrl = async () => {
  const imageUrl = process.env.REACT_APP_ADDRESS + 'public/media/client-logo.png';
  const exists = await _checkImageExists(imageUrl);
  return exists ? imageUrl : null;
};